<template>
  <div class="aboutContainer">
    <h1><v-icon>engineering</v-icon> {{ $t('menu.knowledge')}}</h1>
    <div class="formBloq" v-for="(knowledge,i) in knowledges" :key="i">
      <h2>{{ $t('knowledge.' + knowledge.title) }}</h2>
      <v-expansion-panels>
        <v-expansion-panel v-for="(item,j) in knowledge.items" :key="j" >
          <v-expansion-panel-header>{{ $t('knowledge.' +  item.title) }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            {{ $t('knowledge.' + item.level) }}
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <v-timeline :dense="$vuetify.breakpoint.smAndDown">
      <v-timeline-item v-for="(card, index) in knowCards" :key="index" :color="card.color" fill-dot class="lighten-1">
        <v-card>
          <v-card-title class="lighten-1" :class="[card.color, { 'flex-row-reverse': index%2==1}]">
            <v-icon dark size="42" :class="{ 'mr-4': index%2==0, 'ml-4': index%2==1 }">{{ card.titleIcon }}</v-icon>
            <h2 class="display-1 white--text font-weight-light">{{ $t('knowledge.' + card.title) }}</h2>
          </v-card-title>
          <v-container>
            <v-row :class="{ 'flex-row-reverse': index%2==1 }">
              <v-col cols="12" md="10">
                <p v-for="(text, indTex) in card.texts" :key="indTex">{{ $t('knowledge.' + text) }}</p>
              </v-col>
              <v-col class="hidden-sm-and-down" :class="{ 'text-right': index%2==0 }" md="2">
                <v-icon size="64">{{ card.textIcon }}</v-icon>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
  export default {
    name: 'Knowledge',
    data: () => ({
      knowledges: [{
        title: 'languages',
        items: [{
          title: 'spanish',
          level: 'native',
        },{
          title: 'english',
          level: 'englishLevel',
        }],
      },{
        title: 'drivingLicence',
        items: [{
          title: 'motorVehicle',
          level: 'motorVehicleLevel',
        }],
      }],
      knowCards: [{
        color: 'red',
        titleIcon: 'mdi-robot',
        title: 'ai',
        textIcon: 'mdi-brain',
        texts: [
          'aiText1',
          'aiText2',
        ],
      },{
        color: 'purple',
        titleIcon: 'mdi-server',
        title: 'backend',
        textIcon: 'mdi-note-text',
        texts: [
          'backendText1',
          'backendText2',
        ],
      },{
        color: 'purple',
        titleIcon: 'mdi-server',
        title: 'databases',
        textIcon: 'mdi-database',
        texts: [
          'databasesText1',
          'databasesText2',
        ],
      },{
        color: 'purple',
        titleIcon: 'mdi-server',
        title: 'reports',
        textIcon: 'mdi-file-pdf',
        texts: [
          'reportsText1',
        ],
      },{
        color: 'green',
        titleIcon: 'mdi-monitor',
        title: 'frontend',
        textIcon: 'mdi-note-text',
        texts: [
          'frontendText1',
          'frontendText2',
          'frontendText3',
          'frontendText4',
        ],
      },{
        color: 'orange',
        titleIcon: 'mdi-earth',
        title: 'gis',
        textIcon: 'mdi-note-text',
        texts: [
          'gisText1',
          'gisText2',
          'gisText3',
        ],
      },{
        color: 'cyan',
        titleIcon: 'mdi-server-network',
        title: 'versioning',
        textIcon: 'mdi-source-branch',
        texts: [
          'versioningText1',
          'versioningText2',
        ],
      },{
        color: 'cyan',
        titleIcon: 'mdi-server-network',
        title: 'integration',
        textIcon: 'mdi-atom-variant',
        texts: [
          'integrationText1',
          'integrationText2',
          'integrationText3',
        ],
      },{
        color: 'pink',
        titleIcon: 'mdi-book-open',
        title: 'environments',
        textIcon: 'mdi-linux',
        texts: [
          'environmentsText1',
          'environmentsText2',
          'environmentsText3',
        ],
      },{
        color: 'pink',
        titleIcon: 'mdi-book-open',
        title: 'programming',
        textIcon: 'mdi-note-text',
        texts: [
          'programmingText1',
          'programmingText2',
          'programmingText3',
          'programmingText4',
          'programmingText5',
          'programmingText6',
        ],
      }]
    })
  }
</script>

<style scoped>
  .aboutContainer {
    margin: 20px;
  }

  .formBloq {
    margin: 20px;    
  }
</style>